import { FC } from "react";
import { Box, Button, FormControlLabel, MenuItem, Switch, TextField, Tooltip } from "@mui/material";
import { AppModal } from "../../../../components/ui";
import PlanModel from "../../../../models/plan.model";
import { InviteForm } from "../use-users-page";

type Props = {
    open: boolean;
    onClose: () => void;
    form: InviteForm;
    setField: <K extends keyof InviteForm>(key: K, value: InviteForm[K]) => void;
    plans: PlanModel[];
    isValid: boolean;
    saving: boolean;
    onSubmit: () => void;
};

/** Modal de convite de usuário (nome/e-mail/telefone/plano/função/ativo). */
const InviteUserModal: FC<Props> = ({ open, onClose, form, setField, plans, isValid, saving, onSubmit }) => (
    <AppModal
        open={open}
        onClose={onClose}
        kicker="Cadastrar"
        title="Convidar usuário"
        maxWidth={560}
        footer={
            <>
                <Button variant="outlined" color="secondary" onClick={onClose} sx={{ height: 40, borderRadius: "10px" }}>
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!isValid || saving}
                    onClick={onSubmit}
                    sx={{ height: 40, borderRadius: "10px" }}
                >
                    Convidar
                </Button>
            </>
        }
    >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField label="Nome completo" fullWidth value={form.name} onChange={(e) => setField("name", e.target.value)} />
            <TextField label="E-mail" type="email" fullWidth value={form.email} onChange={(e) => setField("email", e.target.value)} />
            <TextField
                label="Telefone"
                placeholder="(11) 90000-0000"
                fullWidth
                value={form.phone}
                onChange={(e) => setField("phone", e.target.value)}
            />
            <Box sx={{ display: "flex", gap: 2 }}>
                <TextField select label="Plano" fullWidth value={form.plan} onChange={(e) => setField("plan", e.target.value)}>
                    <MenuItem value="">Gratuito</MenuItem>
                    {plans.map((p) => (
                        <MenuItem key={p.id} value={String(p.id)}>
                            {p.name}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField
                    select
                    label="Função"
                    fullWidth
                    value={form.role}
                    onChange={(e) => setField("role", e.target.value as "USER" | "ADMIN")}
                >
                    <MenuItem value="USER">Profissional</MenuItem>
                    <MenuItem value="ADMIN">Administrador</MenuItem>
                </TextField>
            </Box>
            <Tooltip title="Usuário pode acessar a plataforma" placement="top-start">
                <FormControlLabel
                    label="Conta ativa"
                    control={<Switch checked={form.active} onChange={(e) => setField("active", e.target.checked)} />}
                />
            </Tooltip>
        </Box>
    </AppModal>
);

export default InviteUserModal;
